import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var warningIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 3.088 1.685 22h20.63z",
  stroke: "currentColor",
  strokeWidth: "2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.284 18.65a1.15 1.15 0 1 1-2.3 0 1.15 1.15 0 0 1 2.3 0zm-2.4-8.973c.34-.11 1.48-.344 1.756-.242.271.11.435.314.45.56l.114 6.289c-.34.11-1.608.362-1.884.26-.271-.111-.435-.315-.45-.56z",
  fill: "currentColor"
})));

export { warningIcon as default };
//# sourceMappingURL=warningIcon.js.map
